import { pxToRem } from '../../../../utils';
export var inputLabelVariables = function inputLabelVariables(siteVars) {
  return {
    insideLabelBottom: pxToRem(-8),
    insideLabelPaddingLeft: pxToRem(12),
    insideLabelActiveFontSize: pxToRem(12),
    inlineLabelPaddingRight: pxToRem(10),
    lineHeight: pxToRem(16),
    marginBottom: pxToRem(4)
  };
};
//# sourceMappingURL=inputLabelVariables.js.map
